import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'benefits-magic-link-form',
  templateUrl: './magic-link-form.component.html',
  styleUrls: ['./magic-link-form.component.scss'],
  standalone: false
})
export class MagicLinkFormComponent implements OnInit {
  @Input() email = '';
  @Input() pollInterval = 5000;
  @Input() showSpinner = false;
  @Output() pollExpired: EventEmitter<void> = new EventEmitter<void>();
  @Output() requestMfaAlternative: EventEmitter<void> = new EventEmitter<void>();
  @Output() requestResendMagicLink: EventEmitter<void> = new EventEmitter<void>();
  @Output() requestNext: EventEmitter<void> = new EventEmitter<void>();

  ngOnInit(): void {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this;
    setInterval(function () {
      that.pollExpired.emit();
    }, this.pollInterval);
  }

  emitRequestMfaAlternative() {
    this.requestMfaAlternative.emit();
  }

  emitRequestResendMagicLink() {
    this.requestResendMagicLink.emit();
  }

  emitRequestNext() {
    this.requestNext.emit();
  }
}
